import { useState, useRef, useEffect } from 'react';

// Compacte multi-select van klantcontacten (auditees).
// props: contacts [{id,name,role,email}], value (array ids), onChange(ids), placeholder, idPrefix
export default function AuditeeMultiSelect({ contacts = [], value = [], onChange, placeholder, idPrefix = 'auditee' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [open]);

  const sel = new Set(value.map(String));
  const toggle = (id) => {
    const s = new Set(value.map(String));
    s.has(String(id)) ? s.delete(String(id)) : s.add(String(id));
    onChange([...s].map(Number));
  };
  const selectedNames = contacts.filter(c => sel.has(String(c.id))).map(c => c.name);

  return (
    <div className="position-relative d-inline-block" ref={ref} style={{ minWidth: 240 }}>
      <button type="button" className="btn btn-sm btn-outline-secondary w-100 text-start d-flex justify-content-between align-items-center"
        onClick={() => setOpen(o => !o)}>
        <span className="text-truncate">
          {selectedNames.length ? selectedNames.join(', ') : <span className="text-muted">{placeholder}</span>}
        </span>
        <i className="bi bi-chevron-down ms-2" style={{ fontSize: 10 }} />
      </button>
      {open && (
        <div className="card shadow-sm position-absolute mt-1 p-2"
          style={{ zIndex: 300, minWidth: 260, maxHeight: 260, overflowY: 'auto' }}>
          {contacts.length === 0 ? (
            <div className="text-muted small px-1">—</div>
          ) : contacts.map(c => (
            <div className="form-check" key={c.id}>
              <input className="form-check-input" type="checkbox" id={`${idPrefix}-${c.id}`}
                checked={sel.has(String(c.id))} onChange={() => toggle(c.id)} />
              <label className="form-check-label small" htmlFor={`${idPrefix}-${c.id}`}>
                {c.name}{c.role ? <span className="text-muted"> — {c.role}</span> : ''}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
